import { TutorialProvider, TutorialProviderStep } from '@approvalmax/ui/src/components';
import { FC, useMemo } from 'react';

import { TransferAccount } from '../TransferAccount/TransferAccount';
import {
    buttonToLeftClassName,
    buttonToRightClassName,
    leftPanelClassName,
    rightPanelClassName,
} from './TransferAccountTutorial.constant';
import { messages } from './TransferAccountTutorial.messages';
import { TransferAccountTutorialProps } from './TransferAccountTutorial.types';

export const TransferAccountTutorial: FC<TransferAccountTutorialProps> = (props) => {
    const steps = useMemo<TutorialProviderStep[]>(
        () => [
            {
                selector: `.${leftPanelClassName}`,
                content: messages.step1,
                position: (data) => [data.right + 24, data.top],
            },
            {
                selector: `.${buttonToRightClassName}`,
                content: messages.step2,
                position: (data) => [data.left, data.top - data.height - 24],
            },
            {
                selector: `.${rightPanelClassName}`,
                content: messages.step3({
                    br: <br />,
                }),
                position: (data) => [data.left - data.width - 24, data.top],
            },
            {
                selector: `.${buttonToLeftClassName}`,
                content: messages.step4,
                position: (data) => [data.left, data.top - data.height - 24],
            },
        ],
        []
    );

    return (
        <TutorialProvider steps={steps} disableInteraction>
            {({ openTour }) => (
                <TransferAccount
                    {...props}
                    openTour={openTour}
                    rightPanelClassName={rightPanelClassName}
                    leftPanelClassName={leftPanelClassName}
                    buttonToLeftClassName={buttonToLeftClassName}
                    buttonToRightClassName={buttonToRightClassName}
                />
            )}
        </TutorialProvider>
    );
};

TransferAccountTutorial.displayName = 'TransferAccountTutorial';
